/* Vowed: one mystery-discount follow-up, 67 seconds after dismissal without signup.
 * Uses Klaviyo's documented klaviyoForms events and openForm command.
 * No email addresses or other customer data are stored here.
 */
(function () {
  'use strict';
  if (window.__vowedPopupFollowUpLoaded || (window.Shopify && window.Shopify.designMode)) return;
  window.__vowedPopupFollowUpLoaded = true;

  var COMPANY = 'VvmgeU';
  var DELAY = 67000;
  var SESSION_KEY = 'vowed.popup-follow-up.v1';
  var RECENT_KEY = 'vowed.popup-follow-up.shown-at.v1';
  var COOLDOWN = 14 * 24 * 60 * 60 * 1000;
  var FOLLOWUPS = { UsaJaq: 'Sh4PkX', VXJkN3: 'QU9dAm' };
  var FOLLOWUP_IDS = Object.keys(FOLLOWUPS).map(function (id) { return FOLLOWUPS[id]; });
  var openForms = new Set();
  var seenOriginals = new Set();
  var timer;
  var state = { pending: null, submitted: false, used: false };

  try {
    var saved = JSON.parse(window.sessionStorage.getItem(SESSION_KEY));
    if (saved && typeof saved === 'object') {
      state.submitted = saved.submitted === true;
      state.used = saved.used === true;
      if (saved.pending && FOLLOWUP_IDS.indexOf(saved.pending.formId) !== -1 &&
          Number.isFinite(saved.pending.dueAt) && saved.pending.dueAt > Date.now() - COOLDOWN &&
          saved.pending.dueAt <= Date.now() + DELAY) state.pending = saved.pending;
    }
  } catch (_) { /* Storage may be unavailable; the current page still works. */ }

  function persist() {
    try { window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(state)); } catch (_) {}
  }

  function recentlyShown() {
    try {
      var shownAt = Number(window.localStorage.getItem(RECENT_KEY));
      return shownAt > 0 && Date.now() - shownAt < COOLDOWN;
    } catch (_) { return false; }
  }

  function cancelForSignup() {
    state.submitted = true;
    state.pending = null;
    window.clearTimeout(timer);
    persist();
  }

  function tryShow() {
    window.clearTimeout(timer);
    if (!state.pending || state.submitted || state.used) return;
    if (recentlyShown()) { state.pending = null; persist(); return; }
    var remaining = state.pending.dueAt - Date.now();
    if (remaining > 0) { timer = window.setTimeout(tryShow, remaining); return; }
    // Never interrupt another form or a hidden browser tab.
    if (document.visibilityState === 'hidden' || openForms.size) return;
    var formId = state.pending.formId;
    state.used = true;
    state.pending = null;
    persist();
    try { window.localStorage.setItem(RECENT_KEY, String(Date.now())); } catch (_) {}
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  window.addEventListener('klaviyoForms', function (event) {
    var detail = event.detail || {};
    if (detail.companyId && detail.companyId !== COMPANY) return;
    var id = detail.formId;
    if (!id) return;
    var metadata = detail.metaData || {};
    // A role choice is only stepSubmit, not an email conversion. Do not store metadata.
    if (detail.type === 'submit' || (detail.type === 'stepSubmit' && (metadata.email || metadata.$email))) {
      cancelForSignup();
      return;
    }
    if (detail.type === 'open') {
      openForms.add(id);
      if (FOLLOWUPS[id]) seenOriginals.add(id);
      if (FOLLOWUP_IDS.indexOf(id) !== -1) {
        state.used = true;
        state.pending = null;
        persist();
      }
    }
    if (detail.type === 'close' || detail.type === 'redirectedToUrl') {
      openForms.delete(id);
      if (detail.type === 'close' && FOLLOWUPS[id] && seenOriginals.has(id) &&
          !state.submitted && !state.used && !state.pending && !recentlyShown()) {
        state.pending = { formId: FOLLOWUPS[id], dueAt: Date.now() + DELAY };
        persist();
      }
      tryShow();
    }
  });
  // Be conservative when someone uses Shopify's separate newsletter signup.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.matches && form.matches('form[action*="/contact"]') &&
        form.querySelector('input[name="contact[email]"]')) cancelForSignup();
  }, true);
  document.addEventListener('visibilitychange', tryShow);
  window.addEventListener('pageshow', tryShow);
  tryShow();
})();
